import { InvoiceView } from '@lemoncloud/lemon-billings-api';
import moment from 'moment';

export const getInvoiceMonths = (invoices: InvoiceView[]): string[] => {
    if (!invoices) {
        return [];
    }

    return invoices
        .map(invoice => Number(invoice?.startedAt))
        .filter(receiptedAt => !!receiptedAt)
        .sort((a, b) => a - b)
        .map(receiptedAt => moment(receiptedAt).format('YYYY.MM'))
        .reduce((acc, cur) => {
            if (!acc.includes(cur)) {
                acc.push(cur);
            }
            return acc;
        }, [] as string[]);
};
